import { Controller } from "stimulus"

export default class extends Controller {
    static targets = [ "loadingBar", "scrollElement", "loadMoreButton" ]
        
    initialize() {
      this.hitCounter = 0
      this.switchTracker = true
    }

    connect() {
      this.resizeObserver = new ResizeObserver(() => this.updateLoadMoreButton())
      this.resizeObserver.observe(this.element)
      requestAnimationFrame(() => requestAnimationFrame(() => this.updateLoadMoreButton()))
    }

    disconnect() {
      this.resizeObserver?.disconnect()
    }

    scroll() {
      const scrollableHeight = this.element.scrollHeight - this.element.clientHeight
      const scrollLevel = scrollableHeight > 0 ? this.element.scrollTop / scrollableHeight : 0

      if(scrollLevel > 0.8) {
        this.loadMore()
      }
    }

    loadMore() {
      if(!this.switchTracker) return

      this.switchTracker = false
      this.hitCounter += 1
      this.setLoading(true)

      const baseUrl = this.element.dataset.url || `/portal`
      const url = new URL(baseUrl, window.location.origin)
      url.searchParams.set("counter", this.hitCounter)

      fetch(url.toString(), { headers: {'Accept': 'text/plain' }})
      .then(response => {
        if(!response.ok) throw new Error(`Research request failed with ${response.status}`)
        return response.text()
      })
      .then((data) => {
        this.scrollElementTarget.insertAdjacentHTML("beforebegin", data)
      })
      .catch(() => {
        this.hitCounter -= 1
      })
      .finally(() => {
        this.switchTracker = true
        this.setLoading(false)
        requestAnimationFrame(() => this.updateLoadMoreButton())
      })
    }

    setLoading(isLoading) {
      this.loadingBarTarget.classList.toggle("d-none", !isLoading)

      if(this.hasLoadMoreButtonTarget) {
        this.loadMoreButtonTarget.disabled = isLoading
        this.loadMoreButtonTarget.textContent = isLoading ? "Loading research…" : "Load more research"
      }
    }

    updateLoadMoreButton() {
      if(!this.hasLoadMoreButtonTarget) return
      if(this.element.clientHeight === 0) return

      const scrollableDistance = this.element.scrollHeight - this.element.clientHeight
      const minimumUsefulScroll = Math.max(100, this.element.clientHeight * 0.15)
      const hasUsableScrollbar = scrollableDistance > minimumUsefulScroll
      this.loadMoreButtonTarget.classList.toggle("d-none", hasUsableScrollbar)
    }
}
